import { ArrowLeft } from "lucide-react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import type { ArticleRecord } from "../../../lib/we0-article-store";

function ArticleContent({ article }: { article: ArticleRecord }) {
  const format = article.contentFormat.toLowerCase();

  if (format === "plain") {
    return <p className="insight-article-plain">{article.content}</p>;
  }

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw, rehypeSanitize]}
    >
      {article.content}
    </ReactMarkdown>
  );
}

export default function InsightArticlePage({
  article,
}: {
  article: ArticleRecord;
}) {
  return (
    <article className="insight-article" lang={article.language}>
      <a className="insight-article-back" href="/insights#articles">
        <ArrowLeft size={16} />
        返回文章列表
      </a>
      <header className="insight-article-header">
        <time dateTime={article.publishedAt}>
          {new Intl.DateTimeFormat("zh-CN", { dateStyle: "long" }).format(
            new Date(article.publishedAt),
          )}
        </time>
        <h1>{article.title}</h1>
        {article.summary && <p>{article.summary}</p>}
      </header>
      {article.coverImageUrl && (
        <img
          className="insight-article-cover"
          src={article.coverImageUrl}
          alt={article.coverImageAlt ?? ""}
        />
      )}
      <div className="insight-article-content">
        <ArticleContent article={article} />
      </div>
    </article>
  );
}
